import type { AlgoliaBaseProduct, AlgoliaProduct } from "@lib/wrappers/algolia";
import { algoliaBrowse, AlgoliaProductProperties } from "@lib/wrappers/algolia";

const DEFAULT_LOCALE = process.env.NEXT_LOCALES?.split(",")[0];

export const DEFAULT_ATTRIBUTES_TO_RETRIEVE: (keyof AlgoliaBaseProduct)[] = [
    AlgoliaProductProperties.articleNumber,
    AlgoliaProductProperties.productColors,
    AlgoliaProductProperties.objectID,
    AlgoliaProductProperties.colorCode,
    AlgoliaProductProperties.categories,
    AlgoliaProductProperties.hasDiscount,
    AlgoliaProductProperties.image,
    AlgoliaProductProperties.imageLabel,
    AlgoliaProductProperties.hasStock,
    AlgoliaProductProperties.name,
    AlgoliaProductProperties.listPriceRaw,
    AlgoliaProductProperties.priceRaw,
    AlgoliaProductProperties.lowestPriceRaw,
    AlgoliaProductProperties.discountPercentageLowestPrice,
    AlgoliaProductProperties.priceWithDiscount,
    AlgoliaProductProperties.priceWithoutDiscount,
    AlgoliaProductProperties.variants,
    AlgoliaProductProperties.backgroundColor,
    AlgoliaProductProperties.discountPercentage,
    AlgoliaProductProperties.badges,
    AlgoliaProductProperties.listPrice,
    AlgoliaProductProperties.bestseller,
    AlgoliaProductProperties.onlineExclusive,
    AlgoliaProductProperties.group,
    AlgoliaProductProperties.collectionClass,
    AlgoliaProductProperties.collectionType,
];

export default async function handler(req, res) {
    if (req.method === "GET") {
        try {
            let hits: AlgoliaProduct[] = [];
            const products = req.query.products?.split(",") || [];

            let filters = req.query.filters?.split(",") || [];
            if (filters.length === 0) {
                filters = products.map((id) => `objectID:${id}`).join(" OR ");
            }

            const attributesToRetrieve =
                req.query.attributesToRetrieve?.split(",") || DEFAULT_ATTRIBUTES_TO_RETRIEVE;

            const facetFilters = req.query.facetFilters?.split(",") || [];
            let stockFacetFilters = ["hasStock:true"];
            if (facetFilters.length > 0) {
                stockFacetFilters = [facetFilters, "hasStock:true"];
            }
            const locale = req.query.locale ? req.query.locale : DEFAULT_LOCALE;

            await algoliaBrowse(locale).browseObjects({
                filters: filters,
                facetFilters: stockFacetFilters,
                attributesToRetrieve: attributesToRetrieve,
                batch: (batch) => {
                    hits = hits.concat(batch);
                },
            });

            res.status(200).json(hits);
        } catch (error) {
            res.status(500).json(error);
        }
    } else {
        res.status(405).json({
            error: {
                message: "This endpoint only takes GET requests",
            },
        });
    }
}
